import { render, staticRenderFns } from "./EntityForm.vue?vue&type=template&id=0c991aea&"
import script from "./EntityForm.vue?vue&type=script&lang=ts&"
export * from "./EntityForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports